import React from 'react';
import type { ViewProps } from 'react-native';

import {
  SweetpassScreenContentSignedIn,
  SweetpassScreenContentSignedOut,
  SweetpassScreenLoading,
} from './subcomponents';

// ────────────────────────────────────────────────────────────────────────────────

export const SweetpassScreenContent = ({
  testID,
  isLoading,
  isSignedIn,
  onPressSignIn,
}: SweetpassScreenContentProps) => {
  if (isLoading) {
    return <SweetpassScreenLoading testID={testID?.concat('.loading')} />;
  }

  return isSignedIn ? (
    <SweetpassScreenContentSignedIn testID={testID} />
  ) : (
    <SweetpassScreenContentSignedOut
      testID={testID?.concat('.signed-out')}
      onPressSignIn={onPressSignIn}
    />
  );
};

type SweetpassScreenContentProps = {
  readonly isLoading: boolean;
  readonly isSignedIn: boolean;
} & Pick<
  React.ComponentProps<typeof SweetpassScreenContentSignedOut>,
  'onPressSignIn'
> &
  Pick<ViewProps, 'testID'>;
